export const isEmpty = (isEdit: boolean, array: any) =>
  isEdit ? array.size === 0 : array.length === 0;
